module.exports = __webpack_public_path__ + "images/category_lp/tablet/assessment_achievements/5_cabf6aa34e0298d2f21baa07165266b0.jpg";